import type { SubscriptionStore } from "@/Modules/Subscription/Store";
import type { SubscriptionApi } from "@/Modules/Models/Api/Subscription";
import type { Subscription } from "@/Modules/Models/Domain/Subscription";

import SubscriptionApiConnector from "@/Services/TherapyApi/Subscriptions";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import camelize from "@/Utils/Camelize";

class UpdateSubscriptionStatusActionHandler {
  constructor(
    private readonly subscriptionStore: SubscriptionStore,
    private readonly subscriptionApiConnector: SubscriptionApiConnector = new SubscriptionApiConnector()
  ) {}

  public async handle(subscriptionUuid: string): Promise<void> {
    try {
      this.subscriptionStore.isLoading = true;

      const subscriptionResponse =
        await this.subscriptionApiConnector.updateSubscriptionStatus(subscriptionUuid);

      this.subscriptionStore.subscription = this.subscriptionApiToDomain(subscriptionResponse);
    } catch (error: unknown) {
      this.subscriptionStore.notification = {
        type: NotificationType.ERROR,
        message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
        code: "generic error",
      };
    } finally {
      this.subscriptionStore.isLoading = false;
    }
  }

  private subscriptionApiToDomain(subscriptionResponse: SubscriptionApi): Subscription {
    return camelize<SubscriptionApi>(subscriptionResponse) as Subscription;
  }
}

export default UpdateSubscriptionStatusActionHandler;
